module.exports = __webpack_public_path__ + "img/seaPalace-2.bc431db3.jpg";